/// <amd-module name="Artifacts/Package/redux/Module" />
import { IPackageDetailsModuleState } from "Artifacts/Package/redux/Contracts";
import { packageReducer } from "Artifacts/Package/redux/Reducer";
import { rootSaga } from "Artifacts/Package/redux/Sagas";
import { ISagaModule } from "redux-dynamic-modules-saga";

const _packageModule: ISagaModule<IPackageDetailsModuleState> = {
  id: "package-details-module",
  reducerMap: {
    packageState: packageReducer,
  },
  sagas: [rootSaga],
};

export const PackageModule = [_packageModule];
